export const StoreNames = Object.freeze({
    SESSION: 'session',
    AUTO_LOGOUT: 'auto-logout',
});
